module.exports = __webpack_public_path__ + "img/3.31f96adc.jpg";